
import articles from '~/mixins/common/pages/articles'
export default {
    name: 'Index',
    mixins: [articles],
}
